import { Col, Row, DatePicker, Form, Space } from "antd";
import { useState } from "react";
import { KardexTable } from "./KardexTable";
import { DateFormats } from "../../../types/typesConstants";
import dayjs from "dayjs";
import { get_inventory_movements_by_filters } from "../../../actions/inventario";
import { AlmacenSelect } from "./../reusable/AlmacenSelect";
import { InputSearchDropdown } from "./../reusable/InputSearchDropdown";
import { SearchBtn, SearchFormUi, FilterBtn } from "../../ui";
import { parseDateFormatBackEnd } from "../../../helpers/utils";
const initialValues = {
  item: null,
  rangofechas: [dayjs(), dayjs()],
  almacen: null,
};
export const KardexSearch = () => {
  const [form] = Form.useForm();
  const [kardexproductos, setKardexproductos] = useState([]);
  const [showAdvancedRows, setShowAdvancedRows] = useState(false);
  const searchKardex = async (item, fechainicio, fechafin, almacen = null) => {
    const datos = await get_inventory_movements_by_filters(
      item,
      fechainicio,
      fechafin,
      almacen,
    );
    setKardexproductos(datos);
  };
  const handleAdvancedRow = () => {
    setShowAdvancedRows(!showAdvancedRows);
    form.setFieldsValue({ almacen: null });
  };
  const handleSubmit = (values) => {
    searchKardex(
      values?.item,
      parseDateFormatBackEnd(values?.rangofechas[0]),
      parseDateFormatBackEnd(values?.rangofechas[1]),
      values?.almacen,
    );
  };
  return (
    <>
      <SearchFormUi
        form={form}
        name="FormKardexSearch"
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues}
        handleSubmit={handleSubmit}
      >
        {showAdvancedRows && (
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={16} lg={10} xl={10}>
              <Form.Item
                name="almacen"
                label="Almacén"
                rules={[
                  {
                    required: showAdvancedRows,
                    message: "El almacén es obligatorio",
                  },
                ]}
              >
                <AlmacenSelect placeholder="Seleccione Almacen" />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col xs={24} sm={24} md={24} lg={20} xl={20} xxl={12}>
            <Form.Item
              name="item"
              label="Item"
              required={false}
              rules={[{ required: true, message: "El Item es obligatorio" }]}
            >
              <InputSearchDropdown placeholder="Seleccione Item" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={10} xl={6} xxl={6}>
            <Form.Item
              name="rangofechas"
              label="Fechas"
              required={false}
              rules={[
                {
                  required: true,
                  message: "Ingrese el rango de fechas",
                },
              ]}
            >
              <DatePicker.RangePicker format={DateFormats.frontend} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Form.Item label="  ">
              <Space wrap>
                <SearchBtn htmlType="submit" />
                <FilterBtn displayText={false} onClick={handleAdvancedRow} />
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </SearchFormUi>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <KardexTable kardexproductos={kardexproductos} />
        </Col>
      </Row>
    </>
  );
};
